// @owners { team: patient-health }
import { push } from 'react-router-redux';
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { generateSendPrescriptionOptionsViewedEvent } from '~shared/lib/analytics/src/events/getSendPrescriptionOptionsViewed';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { createEvent } from '~shared/lib/analytics/src/helper';
import { connect } from '~shared/store';
import { type ReduxDispatchShared } from '~shared/types';
import MedListAddMedicationButton from './MedListAddMedicationButton';

const mapDispatchToProps = (dispatch: ReduxDispatchShared) => ({
  recordButtonClick: () => {
    dispatch(sendAnalyticsEvent(createEvent(EVENTS.ADD_MED_CLICKED)));
  },
  navigateToFork: () => {
    dispatch(sendAnalyticsEvent(generateSendPrescriptionOptionsViewedEvent(ORIGIN_NAMES.ADD_MED_BUTTON)));
    dispatch(
      push({
        pathname: 'me/send-prescription-options',
        state: {
          origin: ORIGIN_NAMES.ADD_MED_BUTTON,
        },
      }),
    );
  },
});

export default connect(null, mapDispatchToProps)(MedListAddMedicationButton);
